__turbopack_context__.v({
  "container": "SimpleFooter-module__r1dG8q__container",
});
